import {Fragment} from 'react'

import Avatar from '@mui/material/Avatar'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'

import {fullName, firstLetterUpperCased} from '../../../lib/tools'

const Continue = props => (
  <Fragment>
    <Stack component='div' sx={{flexDirection: {xs: 'column', md: 'row'}, gap: 2, justifyContent: 'space-between'}}>
      <Stack component='div'>
        <Typography variant='h4' gutterBottom>Choose an account</Typography>
        <Typography variant='body1'>to continue to <Typography color='success' variant='span'>{props.client.name}</Typography></Typography>
      </Stack>
      <Stack component='div' sx={{width: {xs: '100%', md: '50%'}}}>
        <Stack component='div' sx={{flexDirection: 'row', alignItems: 'center'}}>
          <Avatar sx={{bgcolor: '#4E9E9A'}}>{firstLetterUpperCased(props.currentUser?.firstName)}</Avatar>
          <Button onClick={props.onContinue(props.currentUser.id)} variant='text' color='text.primary' sx={{textTransform: 'none', textAlign: 'left'}}>
            <Stack component='div' sx={{width: '100%'}}>
              <Typography variant='body1'>{fullName(props.currentUser)}</Typography>
              <Typography variant='body2' gutterBottom>{props.email.address}</Typography>
            </Stack>
          </Button>
        </Stack>
        <Divider />
      </Stack>
    </Stack>
  </Fragment>
)

export default Continue
